import React from 'react';
import AssessmentTemplateManager from '../AssessmentTemplateManager'; // Reuse the component

function SettingsAssessmentTemplates() {
  return (
    <div className="settings-page settings-assessment-templates">
      {/* <h2>Settings: Assessment Templates</h2> Removed redundant title */}
      <p>Create, view, and manage reusable assessment templates.</p>
      <AssessmentTemplateManager />
    </div>
  );
}

export default SettingsAssessmentTemplates;

